import React, { Component } from "react";
import PropTypes from "prop-types";
import Subscribes from "./subscribes/subscribes";
import VideoList from "./videos/videoList";
import StreamingInfo from "./streamingInfo/streamingInfo";
import { getShowVideos, getShowDetails } from "../services/videoService";
import LoadingStatus from "../constants/loadingStatus";

class Show extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videos: [],
      showDetails: {},
      loadingStatus: LoadingStatus.notStart
    };
  }

  componentDidMount() {
    const { showId } = this.props;
    this.getVideos(showId);
  }

  getVideos = async (showId) => {
    this.setState({
      loadingStatus: LoadingStatus.notStart
    });
    const showDetails = await getShowDetails(showId);
    const videos = await getShowVideos(showId);
    this.setState({
      videos,
      showDetails,
      loadingStatus: LoadingStatus.loaded
    });
  };

  render() {
    const { loadingStatus, videos, showDetails } = this.state;

    return (
      <div className="container">
        <StreamingInfo videos={videos} source="Show" />
        <VideoList loadingStatus={loadingStatus} videos={videos} />
        <div className="row justify-content-around pt-60">
          <a
            href={showDetails.YouTubeUrl || showDetails.TwitchUrl}
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            See More Episodes
          </a>
        </div>
        <Subscribes youtubeLink={showDetails.YouTubeUrl} twitchLink={showDetails.TwitchUrl} />
      </div>
    );
  }
}

Show.propTypes = {
  showId: PropTypes.string.isRequired
};

export default Show;
